export interface UserProfile {
  first_name: string | null;
  last_name: string | null;
}

export interface DisplayNameResult {
  name: string;
  isItalic: boolean;
}

export const getUserDisplayName = (comment: {
  profiles?: UserProfile;
  created_by?: string;
  created_by_uuid?: string | null;
  migration?: boolean;
}): DisplayNameResult => {
  // Check if this is a migrated comment
  if (comment.migration === true) {
    return {
      name: "Import",
      isItalic: true
    };
  }
  
  let displayName = "Unknown User";
  
  // First try to get name from joined profile data
  if (comment.profiles) {
    const fullName = `${comment.profiles.first_name || ''} ${comment.profiles.last_name || ''}`.trim();
    if (fullName) displayName = fullName;
  }
  
  // Fall back to the old created_by field for backward compatibility
  if (displayName === "Unknown User" && comment.created_by && comment.created_by !== "Current User") {
    displayName = comment.created_by;
  }
  
  return {
    name: displayName,
    isItalic: false
  };
};
